module.exports = __webpack_public_path__ + "img/cat-02-ac.20c01324.svg";